<template>
  <Loader :value="promise" theme="default" class="analytics-dashboard">
    <div class="container view">
      <HeaderComponent :title="$metaInfo.title"></HeaderComponent>
      <h1>{{ $t('analytics') }}</h1>
      <section v-if="isDemo" class="analytics-dashboard__content">
        <p>{{ $t('demoAnalyticsDescription') }}</p>
        <img src="/images/analytics/dashboard.png" loading="lazy" alt="Dashboard preview" />
      </section>
      <section v-else class="analytics-dashboard__content">
        <iframe
          plausible-embed
          :src="analyticsUrl"
          scrolling="no"
          frameborder="0"
          loading="lazy"
          style="width: 1px; min-width: 100%; height: 2000px"
        ></iframe>
      </section>
      <SlotComponent placement="analytics" :query="{ project: id }" />
    </div>
  </Loader>
</template>
<script async src="https://staging.analytics.kvass.no/js/embed.host.js"></script>
<script>
import HeaderComponent from '@/components/Header'
import ProjectAPI from '@/api/Project'
import PageAPI from '@/api/Page'
import SlotComponent from '@/components/Slot'

export default {
  props: {
    id: String,
    type: String,
  },
  data() {
    return {
      promise: null,
      data: null,
      api: {
        project: ProjectAPI,
        page: PageAPI,
      },
    }
  },
  watch: {
    id: {
      handler: 'fetch',
      immediate: true,
    },
  },
  computed: {
    isDemo() {
      return this.data && this.data.demo ? this.data.demo : false
    },
    analyticsUrl() {
      return this.data && this.data.metadata && this.data.metadata.analyticsUrl
        ? `${this.data.metadata.analyticsUrl}&embed=true&theme=light&background=transparent`
        : ''
    },
  },
  methods: {
    fetch() {
      if (!this.type) return
      this.data = null
      this.promise = this.api[this.type]
        .get({
          id: this.id,
        })
        .then(data => {
          this.data = data
        })
    },
  },
  metaInfo() {
    return {
      title: this.data && this.data.name ? `${this.$tc(`${this.type}`, 1)} ${this.data.name}` : this.$t('dashboard'),
    }
  },

  components: {
    HeaderComponent,
    SlotComponent
  },
}
</script>

<style lang="scss">
.analytics-dashboard {
  background-color: $background-grey;

  &__content {
    margin-top: 2rem;
    width: 100%;
    max-width: 100%;
    position: relative;

    img {
      max-width: 100%;
      width: 100%;
    }
  }
}
</style>
